import { FC } from 'react';
import {
  styled,
  TableCell as MuiTableCell,
  tableCellClasses,
  TableCellProps as MuiTableCellProps,
} from '@mui/material';
import classNames from 'classnames';

const StyledTableCell = styled(MuiTableCell)`
  white-space: nowrap;

  &.normal-padding {
    padding: ${({ theme }) => theme.spacing()};
  }

  &.${tableCellClasses.head} {
    padding: ${({ theme }) => theme.spacing(0.75, 1)};

    &:first-of-type {
      padding-left: ${({ theme }) => theme.spacing(1.5)};
    }

    &:last-of-type {
      padding-right: ${({ theme }) => theme.spacing(1.5)};
    }
  }

  &.minimal-width {
    width: 1%;
  }

  &.narrow {
    width: 10%;
  }

  &.centered {
    text-align: center;
  }
`;

export type TableCellProps = MuiTableCellProps & {
  /**
   * If `true`, the table cells will be no wider than their contents
   */
  minimalWidth?: boolean;
  /**
   * If `true`, the table cells witll be narrower than normal
   */
  narrow?: boolean;
};

export const TableCell: FC<TableCellProps> = ({
  padding,
  minimalWidth,
  narrow,
  className,
  ...props
}) => (
  <StyledTableCell
    className={classNames(className, {
      'minimal-width': minimalWidth,
      'normal-padding': !padding || padding === 'normal',
      narrow,
    })}
    padding={padding}
    {...props}
  />
);
